// This function provides feature support detection for file upload using drag and drop.
// This will allow us to hide the drag and drop feature on mobile and old browsers.
export default () => {
  const div = document.createElement('div');
  return (
    ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
  );
};
